import React from 'react';
import styles from './StockStatus.module.css';

const StockStatus = ({ products, loading, error }) => {
  const renderCategory = (categoryName, categoryKey) => {
    const categoryProducts = Object.entries(products || {})
      .filter(([, details]) => details.category === categoryKey && details.stock !== undefined)
      .sort(([a], [b]) => a.localeCompare(b));

    if (categoryProducts.length === 0) {
      return null;
    }
    return (
      <div className={styles.categorySection}>
        <h5>{categoryName}</h5>
        <ul className={`${styles.stockList} ${styles[categoryKey]}`}>
          {categoryProducts.map(([name, details]) => {
            // Lógica para definir a classe do item
            let itemClass = '';
            if (details.stock === 0) {
              itemClass = styles.outOfStock;
            } else if (details.stock <= 5) {
              itemClass = styles.lowStock;
            }
            return (<li key={name} className={itemClass}>
              <span className={styles.productName}>{name}</span>
              <strong className={styles.stockQuantity}>{details.stock}</strong>
            </li>
          )})}
        </ul>
      </div>
    );
  };

  if (loading) {
    return <div className={styles.stockContainer}>Carregando estoque...</div>;
  }
  if (error) {
    return <div className={`${styles.stockContainer} ${styles.error}`}>{error}</div>;
  }

  return (
    <div className={styles.stockContainer}>
      <h4 className={styles.stockTitle}>Estoque Atual</h4>
      <div className={styles.categoriesWrapper}>
        {renderCategory('🍖 Assados', 'assados')}
        {renderCategory('🥗 Acompanhamentos', 'acompanhamentos')}
        {renderCategory('🥤 Bebidas', 'bebidas')}
      </div>
    </div>
  );
};

export default StockStatus;
